import { Tabs } from "@/components/ui/tabs";
import { Form } from "@/components/ui/form";
import { useListingWizardContext } from "@/context/ListingWizardContext";
import { getStepTabValue } from "./utils/formUtils";
import FormStepTabs from "./FormStepTabs";
import FormStepContent from "./FormStepContent";
import FormNavigation from "./FormNavigation";
import FormProgressBar from "./FormProgressBar";

const FormLayout = () => {
  const { form, currentStep, setCurrentStep, completedSteps } =
    useListingWizardContext();

  return (
    <div className="max-w-5xl mx-auto">
      <FormProgressBar />

      <Tabs
        value={getStepTabValue(currentStep)}
        className="w-full"
        onValueChange={(value) => {
          const step = parseInt(value.split("-")[1]);

          // Allow navigation to any previous step or the current step
          // Only restrict navigation to future steps if they are not completed
          if (
            step < currentStep ||
            completedSteps[step] ||
            step === currentStep
          ) {
            setCurrentStep(step);
          }
        }}
      >
        <FormStepTabs />

        <Form {...form}>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default form submission
            }}
            className="space-y-6"
          >
            <FormStepContent />
            <FormNavigation />
          </form>
        </Form>
      </Tabs>
    </div>
  );
};

export default FormLayout;
